import * as types from './action-types';

export function setInvoicePage (invoice) {
  return {
    type: types.SET_INVOICE_PAGE,
    payload: invoice
  };
}

export function setPreregisteredInvoicePage (preregisteredInvoice) {
  return {
    type: types.SET_PREREGISTERED_INVOICE_PAGE,
    payload: preregisteredInvoice
  };
}

export function setScrollPosition (scrollPosition) {
  return {
    type: types.SET_SCROLL_POSITION,
    payload: scrollPosition
  };
}

export function clear () {
  return {
    type: types.CLEAR_SCROLL_POSITION
  };
}



/** WEBPACK FOOTER **
 ** ./src/redux/modules/scroll-positions/index.js
 **/